import React, { ReactElement } from 'react';
import { FastField as FormikField } from 'formik';
import { Field as UnionField } from '../../gs-component-form';
import { FormRow, FormColumn } from '@xo-union/tk-component-form-grid';
import { Body1 } from '@xo-union/tk-ui-typography';
import Checkmark from '../Checkmark';
import SectionHeader from '../SectionHeader';
import { Event, Invitation } from '../interfaces';

interface GiftsProps {
  invitations: Invitation[];
  events: Event[];
}

const Gifts: React.FC<GiftsProps> = ({ invitations, events }) => {
  return (
    <>
      <SectionHeader>Gifts</SectionHeader>
      {invitations?.map(({ eventId }, index) => {
        const thankYou = `invitations.${index}.thankYouSent`;
        const gift = `invitations.${index}.gift`;
        const foundEvent = events.find(event => event.id === eventId);
        const { name: eventName } = foundEvent || {};

        if (!eventName) return null;
        return (
          <div key={gift}>
            <Body1 bold>{eventName}</Body1>
            <FormikField name={thankYou}>
              {({ field }: { field: any }): ReactElement => (
                <Checkmark id={field.name} label="Thank You Sent" disabled={false} {...field} />
              )}
            </FormikField>
            <FormRow>
              <FormColumn md>
                <FormikField name={gift} label="Gift Received" component={UnionField} />
              </FormColumn>
            </FormRow>
          </div>
        );
      })}
    </>
  );
};

export default Gifts;
